import apiService from "./api";

const galleryService = {
  // Gallery operations
  getGalleryImages() {
    return apiService.get("/gallery");
  },
  uploadGalleryImage(formData, config = {}) {
    return apiService.post("/gallery", formData, config);
  },
  deleteGalleryImage(imageId) {
    return apiService.delete(`/gallery/${imageId}`);
  },
};

export default galleryService;
